import { branding, Colour_Tournament, PushOver } from "./Utils";

export class Name {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Name";
    this.scene = "Name";
    this.data = [];
    this.page = 7000;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });
      xml = branding({ game: options.game, team: options.team, xml });
      xml = PushOver({ push_over: options.push_up, xml });
      xml.payload.field.find((item) => {
        return item.attr.name === "0004";
      }).value = options.line_2 && options.line_2 !== "" ? 2 : 1;

      xml.payload.field.find((item) => {
        return item.attr.name === "102";
      }).value = options.player.first_name || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "103";
      }).value = options.player.last_name || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "101";
      }).value = options.show_number ? options.player?.shirt_number || "" : "";

      xml.payload.field.find((item) => {
        return item.attr.name === "200";
      }).value =
        (options.line_1 || options.subtext || options.team?.name || "") +
        (options?.player?.title ? " " + options?.player?.title : "");

      xml.payload.field.find((item) => {
        return item.attr.name === "300";
      }).value = options.line_2 || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "100";
      }).value = options.team?.variables?.badge || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "104";
      }).value =
        "IMAGE*__SKY_SPORTS/GLOBALS/FLAGS_OUTLINE/" +
        (options.player?.nationality?.code?.toLowerCase() ||
          options.player?.nationality?.opta_code?.toLowerCase() ||
          "");

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
